export const commonValues = {
  maxFilesLength: 10,
  maxFileSize: 10,
};
